module.exports = __webpack_public_path__ + "img/atlanta_content_img_03_2.174b1d6e.jpg";